import React, { CSSProperties, FC, useMemo } from 'react';
import classNames from 'classnames';
import classes from './styles/index.module.scss';
import { ErrorBoundary } from '../../../../../../ReactSharedScripts/components/ErrorBoundary';

type SpreadsheetProps = {
	className?: string;
	minWidth?: string;
	dataTestId?: string;
	style?: CSSProperties;
};

export const Spreadsheet: FC<React.PropsWithChildren<SpreadsheetProps>> = ({
	className,
	children,
	minWidth,
	dataTestId,
	style,
}) => {
	const componentClasses = classNames(classes.spreadsheet, className);

	const styles = useMemo(
		() => ({
			...style,
			minWidth,
		}),
		[minWidth, style],
	);

	return (
		<ErrorBoundary>
			<section
				className={componentClasses}
				style={styles}
				data-testid={dataTestId}
			>
				{children}
			</section>
		</ErrorBoundary>
	);
};
